import WfGroup from '../../public/wf-group/index';
import { getAntd,getEcCom } from '../../util/convert';
import { observer,inject } from "mobx-react/index";
import * as mobx from 'mobx';

@inject('globalStore')
@observer
export default class Main extends React.Component {

	constructor(props) {
		super(props);
        // this.state = {
        //     Intervenorid_viewAttr:3,
        //     Intervenorid_crm_viewAttr:3
        // };
	}

	render() {
		const { Row, Col } = getAntd();
		const {WeaBrowser,WeaSelect} = getEcCom();
		const {invertionInfo = {} ,variableMap ={}} = this.props.globalStore;
		const {title,items = [],enableInterSpan ='',replacedatas,replacedatas_crm} = mobx.toJS(invertionInfo);
		const {Intervenorid_replaceDatas = [] ,Intervenorid_crm_replaceDatas = [],Intervenorid_viewAttr,Intervenorid_crm_viewAttr} = mobx.toJS(variableMap);
		const com =  this.getInterventionContent(items,enableInterSpan,Intervenorid_replaceDatas,Intervenorid_crm_replaceDatas,Intervenorid_viewAttr,Intervenorid_crm_viewAttr);
		return(
			<div className='wf-req-intervenor'>
        		<WfGroup ecId={`${this && this.props && this.props.ecId || ''}_WfGroup@5jio6n`} title={title} needTigger={false} groupBodyComponent={com}/>
        	</div>
		)
	}
	
	getInterventionContent(items =[],enableInterSpan,_replacedatas,_replacedatas_crm,Intervenorid_viewAttr,Intervenorid_crm_viewAttr){
		const { Row, Col } = getAntd();
		const {WeaBrowser,WeaSelect} = getEcCom();
		const {submitParam ={}} = this.props.globalStore;
		let SignType = submitParam.SignType || '0';
		let random = Math.random();
		return (
			<div>
				{
					items.map((item = {})=>{
						const domKey = typeof item.domkey === "object" ? item.domkey[0] : item.domkey;
						const {labelcol,fieldcol,label,conditionType,domkey = [],browserConditionParam = {},options=[],viewAttr = 2} = item;
						let com = '';
						if(conditionType === 'SELECT'){
							com = <WeaSelect ecId={`${this && this.props && this.props.ecId || ''}_WeaSelect@e1gk1h@${domKey}`} options={options} style={{'minWidth':'120px'}} viewAttr={viewAttr} widthMatchOptions={false} fieldName={domkey[0]} onChange={this.doSelectChangeEvent.bind(this,domkey[0])}/>
						}else if(conditionType === 'BROWSER'){
							let inputStyle = {"width":'300px'};
							
							let {replaceDatas = []} = browserConditionParam;
							let viewAttr = 3;
							//if(_replacedatas){
								if(domkey == "Intervenorid_crm"){
									browserConditionParam.replaceDatas = _replacedatas_crm;
									viewAttr=Intervenorid_viewAttr;
								}else{
									browserConditionParam.replaceDatas = _replacedatas;
									viewAttr=Intervenorid_crm_viewAttr;
								}
							//}
							com = <WeaBrowser ecId={`${this && this.props && this.props.ecId || ''}_WeaBrowser@af46pi@${domKey}`} {...browserConditionParam} viewAttr={viewAttr}  key={random} replaceNotCtrl={true} layout={document.body} inputStyle={inputStyle} fieldName={domkey[0]} onChange={this.doBrowserChangeEvent.bind(this,domkey[0])}/>
						}
						return (
							(domkey == 'Intervenorid_crm' && SignType == '2') ? <span/> : (<Row ecId={`${this && this.props && this.props.ecId || ''}_Row@tq7seb@${domKey}`}>
								<Col ecId={`${this && this.props && this.props.ecId || ''}_Col@tlicya@${domKey}`} span={labelcol}>{label}</Col>
								<Col ecId={`${this && this.props && this.props.ecId || ''}_Col@7l4j3b@${domKey}`} span={fieldcol}>
									{com}
									{domkey[0] == 'enableIntervenor' && <span style={{"color":"#FF4848","marginLeft":"5px"}}>{enableInterSpan}</span>}
								</Col>
							</Row>)
						)
					})
				}
			</div>
		)
	}
	
	doSelectChangeEvent(domkey,v){
		const {changeSubmitParam,getInterventionUser,controlVariableMap,submitParam} = this.props.globalStore;
		const {SignType = ''} = submitParam;
		let updateinfo  = {};
		updateinfo[domkey] = v;
        changeSubmitParam(updateinfo);

		if(domkey == 'submitNodeId'){
			if(v) {
				let arr = v.split("_");
		        const selnodeid=arr[0];
        		const selnodetype=arr[1];
                getInterventionUser({nodeid:selnodeid,'nodetype':selnodetype,'SignType' : SignType});
			}
		}
		if(domkey == 'SignType'){
			this.cahngeViewAttr();
		}

	}
	
	doBrowserChangeEvent(domkey,ids,names,data){
        const {changeSubmitParam,submitParam,controlVariableMap} = this.props.globalStore;
		let updateinfo  = {};
		updateinfo[domkey] = ids;
		changeSubmitParam(updateinfo);
		controlVariableMap(domkey+"_replaceDatas",data);
		this.cahngeViewAttr();
	}

	cahngeViewAttr = () =>{
        const {changeSubmitParam,submitParam,controlVariableMap} = this.props.globalStore;
		const {Intervenorid = "",Intervenorid_crm = "", SignType = ''} = submitParam;
		let ismandatory = (Intervenorid == undefined || Intervenorid == "") && (Intervenorid_crm == undefined || Intervenorid_crm == "");
		if(SignType == '2'){//依次逐个处理
			//清空客户操作者并隐藏
			let updateinfo  = {};
			updateinfo.Intervenorid_crm = '';
			changeSubmitParam(updateinfo);
			controlVariableMap("Intervenorid_crm_replaceDatas",[]);
			ismandatory = (Intervenorid == undefined || Intervenorid == "");
		}

		if(ismandatory){
			controlVariableMap("Intervenorid_viewAttr",3);
			controlVariableMap("Intervenorid_crm_viewAttr",3);
		}else{
			controlVariableMap("Intervenorid_viewAttr",2);
			controlVariableMap("Intervenorid_crm_viewAttr",2);
		}
	}

}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/main/Intervention.js